module.exports = { 
      attributes: {"title":"Shogi Spielabende nach Corona Pause","date":"2020-06-13T00:00:00.000Z","author":"Richi","categories":["news"],"tags":["news"],"language":"de","section":null},
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = function render() { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0) };
            this.$options.staticRenderFns = [function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"markdown-body"},[_c('p',[_vm._v("Nach einer Zwangspause hat sich die Lage in Berlin etwas entspannt,\nsodass wir am 11.06 mit dem Shogibetrieb wieder angefangen haben.\nAktuell sind nun bis zu 5 Personen aus mehreren Haushalten erlaubt.")]),_vm._v(" "),_c('p',[_vm._v("Die Räume sind gleich geblieben, nur die Vorschriften mussten angepasst werden.")]),_vm._v(" "),_c('p',[_vm._v("Ab sofort gibt es eine angemessene Hygieneprotokoll als Vorsichtsmaßnahme:")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("Handdesinfektion vor und nach jeder Runde")]),_vm._v(" "),_c('li',[_vm._v("Anwesenheitsliste zur Nachverfolgung")]),_vm._v(" "),_c('li',[_vm._v("Mund-Nase-Bedeckung.")])])]) }];
          }
        }
      },
     }